import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { createQueryKeyFactory } from "@circle-react/lib/queries/createQueryKeyFactory";
import { queryClient } from "@circle-react/providers/QueryClient/reactQueryConfig";
import type { AuxiliarySubscriptionResponse } from "@circle-react/types/UsageBilling";
import { queryOptions } from "react-query";

export const auxiliarySubscriptionKey = createQueryKeyFactory(
  "community-billing-auxiliary-subscription",
);

export const auxiliarySubscriptionQueries = {
  show: () =>
    queryOptions({
      queryKey: auxiliarySubscriptionKey.key("show"),
      queryFn: () =>
        reactQueryGet<AuxiliarySubscriptionResponse>(
          internalApi.communities.billing.auxiliarySubscription.show(),
        ),
    }),
};

export const auxiliarySubscriptionInvalidations = {
  all: () =>
    queryClient.invalidateQueries({
      queryKey: auxiliarySubscriptionKey.root(),
    }),
};
